import { BlockDataForm } from '@plone/volto/components';
import { useIntl } from 'react-intl';
import { cardSchema } from './schema';

const CardData = (props) => {
  const { data, block, onChangeBlock } = props;
  const intl = useIntl();
  const schema = cardSchema({ ...props, intl });
  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

export default CardData;
